import { Trans, useLingui } from '@lingui/react/macro';

import InputNumber from '@/design_system/InputNumber';
import { OptionalLabel } from '@/design_system/Label/OptionalLabel';
import { useUpdateArticle } from '@/models/article';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import {
  WEIGHT_UNIT_LABELS,
  WEIGHT_UNIT_MAXIMUM_FRACTION_DIGITS,
  WeightUnit,
} from '@/utils/weight';

export const Weight = () => {
  const { t } = useLingui();
  const { request, article, view, errors } = useArticleContext();
  const { mutate: updateArticle } = useUpdateArticle(
    {
      articleId: article.id,
      requestId: request.id,
    },
    {
      optimistic: true,
    }
  );
  const weightUnitFromAttribute = [...article.productAttributeValues]
    .reverse()
    .find((productAttributeValue) => !!productAttributeValue.weightUnit)?.weightUnit;
  const weightUnit: WeightUnit = article.weight?.unit ?? weightUnitFromAttribute ?? 'gram';
  const weightUnitLabel = WEIGHT_UNIT_LABELS[weightUnit];

  return (
    <InputNumber
      label={
        <>
          <Trans id="article.form.weight.label">Weight</Trans>
          {!view.details.weight.required && <OptionalLabel />}
        </>
      }
      style={{ flex: 1 }}
      value={article.weight?.amount ?? NaN}
      onChange={(amount) => {
        updateArticle({
          data: {
            weight: !!amount || amount === 0 ? { amount, unit: weightUnit } : null,
          },
        });
      }}
      minValue={0}
      formatOptions={{
        style: 'unit',
        unit: weightUnit,
        unitDisplay: 'short',
        maximumFractionDigits: WEIGHT_UNIT_MAXIMUM_FRACTION_DIGITS[weightUnit],
      }}
      error={
        errors?.details?.missingWeight
          ? t({ id: 'article.form.weight.error', message: 'Please enter the weight' })
          : undefined
      }
      placeholder={t({
        id: 'article.form.weight.placeholder',
        message: `Enter the weight (${weightUnitLabel})...`,
      })}
    />
  );
};
